<i nz-icon nzType="shopping-cart"></i>
<span class="cart-empty-notification-title mb-2">{{ 'cart.emptyCart_text' | cxTranslate }}</span>
<span class="cart-empty-notification-description">{{ 'cart.emptyCart_hint' | cxTranslate }}</span>
